import axios from 'axios';

const loadAbort = () => {
  return new AbortController();
};

export const getRolesEndpoint = (token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/user/v1/admin/internal-users/roles`,
        headers: {
          'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};